import styled from 'styled-components';

export namespace AuthBaseCardHeaderCSS {
  export const Container = styled.div`
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.s};
    margin-bottom: ${({ theme }) => theme.spacing.m};
    padding: ${({ theme }) => theme.spacing.m} 0;
    width: 100%;
  `;

  export const Title = styled.div`
    color: ${({ theme }) => theme.colors.text.default};
    font-size: ${({ theme }) => theme.typography.font.size.xl};
    font-weight: ${({ theme }) => theme.typography.font.weight.medium};
    line-height: ${({ theme }) => theme.typography.lineHeight.small};
    text-align: center;
  `;
}
